/* esm.sh - canvas-color-tracker@1.3.2 */
export * from "/*canvas-color-tracker@1.3.2/esnext/canvas-color-tracker.mjs";
export { default } from "/*canvas-color-tracker@1.3.2/esnext/canvas-color-tracker.mjs";
